import React from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import "./marketing.css";
import logo from "../../assets/images/tracklastmile-logo.svg";
import profile from "../../assets/images/profile-img.png";

const FreeTrial = () => {
  return (
    <div className="tlm-home tlm-dark min-vh-100">
      <div className="d-flex justify-content-center pt-4 pb-2">
        <Link to="/">
          <img src={logo} alt="TrackLastMile" className="img-fluid d-block tlm-home-logo" />
        </Link>
      </div>

      <div className="account-pages my-4 pt-sm-4 pb-4">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="tlm-soft-primary-dark">
                  <Row>
                    <Col className="col-7">
                      <div className="text-dark p-4">
                        <h5 className="text-dark mb-2">14-Day Free Trial</h5>
                        <p className="mb-0">
                          Start onboarding stores and drivers now.
                          <br />
                          No credit card required.
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Trial" className="img-fluid" />
                    </Col>
                  </Row>
                </div>

                <CardBody className="pt-0">
                  <div className="p-3 p-md-4 text-center">
                    <h1 className="h4 font-weight-bold mb-3 text-dark">Start Free Trial</h1>
                    <p className="text-muted mb-4">
                      Create your trial account and launch your branded delivery
                      operation in minutes.
                    </p>
                    <div className="d-flex flex-wrap justify-content-center">
                      <Button
                        color="primary"
                        tag={Link}
                        to="/trial-register"
                        className="m-2 px-4"
                      >
                        Create Trial Account
                      </Button>
                      <Button
                        color="outline-dark"
                        tag={Link}
                        to="/pricing"
                        className="m-2 px-4"
                      >
                        Compare Plans
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center tlm-text-muted">
                <p className="mb-0">
                  Need help selecting a plan? <Link to="/trial-register">Book a demo</Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default FreeTrial;
